import React, { useContext, useEffect, useRef, useState } from "react";
import { StyleSheet, useColorScheme, View } from "react-native";
import { Modal, Text, TextInput, TouchableOpacity } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import Spinner from "../../../components/shared/Spinner";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import { useDispatch, useSelector } from "react-redux";
import { ChinaTrackerDataTableWithPagination2 } from "../../../components/custom/DataTable/tracker/ChinaTrackerDataTableWithPagination2";

interface TrackerEnquiryModalProps {
  visible: boolean;
  onClose: any;
  order: string;
}

const TrackerHistoryReplyModal: React.FC<TrackerEnquiryModalProps> = ({
  visible,
  onClose,
  order,
}: any) => {
  const listRef = useRef<ScrollView>(null);

  const [isSearched, setIsSearched] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);

  const { loadingEnquiries } = useSelector(
    (state: any) => state.productTracker
  );

  const headers = {
    createdAt: {
      name: "Inquiry Date",
      width: 0.4,
    },
    createdBy: {
      name: "User",
      width: 0.3,
    },
    subject: {
      name: "Subject",
      width: 0.2,
    },
    priority: {
      name: "Priority",
      width: 0.2,
    },
    message: {
      name: "Message",
      width: 0.5,
    },
  };

  const [isRefresh, setRefresh] = useState<boolean>(false);

  const [tableHeaders, setTableHeaders] = useState<any>(headers);

  const { isLargeDevice, isMediumDevice, isSmallDevice } = useContext(
    DeviceOrientationContext
  );
  const [, setContentOffSet] = useState<number>(0);

  const handleScroll = (event: any) => {
    setContentOffSet(Math.floor(event.nativeEvent?.contentOffset?.y) ?? 0);
  };

  useEffect(() => {
    let isMounted: boolean = true;

    setTableHeaders(headers);
    setRefresh(false);

    return () => {
      isMounted = false;
    };
  }, [isRefresh]);

  return (
    <Modal visible={visible} transparent animationType="slide">
      <View style={styles.overlay}>
        <View
          style={
            isLargeDevice ? styles.modalContainer : styles.modalContainerSecond
          }
        >
          <View style={styles.header}>
            <TouchableOpacity onPress={onClose} style={styles.backButton}>
              <Text style={styles.backArrow}>←</Text>
            </TouchableOpacity>
            <Text style={styles.title}>History</Text>
          </View>

          <ScrollView onScroll={handleScroll} ref={listRef}>
            <View>
              <View>
                <View
                  style={[
                    styles.containerContent,
                    {
                      width: isLargeDevice
                        ? "100%"
                        : isMediumDevice
                        ? "100%"
                        : "100%",
                    },
                  ]}
                >
                  {!loadingEnquiries ? (
                    <View>
                      <ChinaTrackerDataTableWithPagination2
                        headers={tableHeaders}
                        rows={order?.childEnquiries}
                        itemsPerPage={10}
                        isDataLoading={isSearched}
                        isDisplayTimeWithDate={true}
                        useModal={true}
                        isDetail={false}
                        isEdit={false}
                        isDelete={false}
                        // Required props
                        setModalVisible={() => {}}
                        handleRowClick={() => {}}
                        setSelected={() => {}}
                        handleDeleteRow={() => {}}
                        page={page}
                        setPage={setPage}
                      />
                    </View>
                  ) : (
                    <View>
                      <Spinner
                        size="small"
                        color="#74BBFF"
                        styles={{ flexDirection: "row", margin: "20%" }}
                      />
                    </View>
                  )}
                </View>
              </View>
            </View>
          </ScrollView>
          <View style={styles.footer}>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <Text>Close</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.2)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    backgroundColor: "#fff",
    padding: 25,
    width: "76%",
    borderRadius: 10,
  },
  title: {
    fontSize: 25,
    fontWeight: "bold",
    marginBottom: 35,
  },
  detailsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 15,
  },
  column: {
    flex: 1,
  },
  label: {
    fontWeight: "bold",
    fontSize: 16,
    marginBottom: 3,
  },
  value: {
    fontSize: 16,
    marginBottom: 10,
    paddingLeft: 4,
  },
  dropdownRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  dropdownContainer: {
    flex: 1,
    marginRight: 10,
  },
  inputLabel: {
    fontWeight: "bold",
    marginBottom: 5,
    marginTop: 20,
  },
  picker: {
    borderWidth: 1.5,
    borderColor: "#a6a6a6",
    height: 40,
    backgroundColor: "#fff",
    borderRadius: 10,
  },
  messageInput: {
    height: 100,
    borderWidth: 1.5,
    borderColor: "#a6a6a6",
    padding: 10,
    backgroundColor: "#fff",
    marginBottom: 15,
    borderRadius: 10,
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  userName: {
    fontSize: 14,
  },
  submitButton: {
    backgroundColor: "#000",
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 5,
  },
  submitText: {
    color: "#fff",
    fontWeight: "bold",
  },
  closeButton: {
    padding: 10,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 5,
  },
  buttonPrimary: { padding: 10, backgroundColor: "black", borderRadius: 5 },
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    flexGrow: 1,
  },
  containerContent: {
    flexDirection: "column",
    alignSelf: "flex-start",
  },

  fab: {
    bottom: -10,
    position: "absolute",
    zIndex: 1,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 30,
    paddingBottom: 10,
  },
  backButton: {
    marginRight: 15,
    padding: 5,
  },
  backArrow: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#000",
  },
  title: {
    fontWeight: "600",
    flex: 1,
    color: "#000",
    fontSize: 18,
  },
  modalContainerSecond: {
    backgroundColor: "#fff",
    elevation: 8,
    height: "100%",
    width: "100%",
    padding: 10,
  },
});

export default TrackerHistoryReplyModal;
